export default function levenshteinDistance(a: string, b: string): number {
  a = (a ?? "").toLowerCase();
  b = (b ?? "").toLowerCase();

  const dp: number[][] = Array.from({ length: a.length + 1 }, () =>
    Array(b.length + 1).fill(0)
  );

  for (let i = 0; i <= a.length; i++) dp[i][0] = i;
  for (let j = 0; j <= b.length; j++) dp[0][j] = j;

  for (let i = 1; i <= a.length; i++) {
    for (let j = 1; j <= b.length; j++) {
      const cost = a[i - 1] === b[j - 1] ? 0 : 1;

      dp[i][j] = Math.min(
        dp[i - 1][j] + 1,       // delete
        dp[i][j - 1] + 1,       // insert
        dp[i - 1][j - 1] + cost // replace
      );
    }
  }

  return dp[a.length][b.length];
}
